
<!-- command-bar -->
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Formularios</h2>
  </div>
  <app-data-table tableId="datatableFormularios" [serverSide]="true" [serverData]="getDataTableFormularios" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
</div>

<!-- Nuevo -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-formulario" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Formulario</div>
    <form [formGroup]="formForm" (ngSubmit)="crearEditarFormulario()" name="formForm">
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box [frm]="formForm" formControlName="Nombre" type="text" [required]="true" label="Nombre"></app-text-box>
          <!-- <label 
            class="ms-Label is-required" 
            for="Nombre">
              Nombre
          </label>
          <input
            class="text-Create form-control"
            type="text"
            placeholder="Nombre"
            [(ngModel)]="formularioObj.Nombre"
            formControlName="Nombre"
          />
          <p 
            style="color: brown;" 
            *ngIf="formForm.controls.Nombre.invalid && (formForm.controls.Nombre.dirty || formForm.controls.Nombre.touched)"> 
              El nombre del formulario no cuenta con el formato correcto 
          </p> -->
        </div>
        <div>
          <app-text-area [frm]="formForm" formControlName="Descripcion" [required]="true" label="Descripción" rows="3"></app-text-area>
          <!-- <label 
            class="ms-Label is-required" 
            for="Descripcion">
              Descripción
          </label>
          <textarea
            class="text-Create form-control"
            rows="3"
            placeholder="Descripción..."
            [(ngModel)]="formularioObj.Descripcion"
            formControlName="Descripcion"
          ></textarea> 
          <p 
            style="color: brown;" 
            *ngIf="formForm.controls.Descripcion.invalid && (formForm.controls.Descripcion.dirty || formForm.controls.Descripcion.touched)"> 
              La descripción del formulario no cuenta con el formato correcto 
          </p> -->
        </div>
        <div>
          <div class="ms-Dropdown dropdown" tabindex="0">
            <label 
              class="ms-Label is-required"
              for="Estado">
                Estado
            </label>
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"
            ></i>
            <select
              class="form-control"
              [(ngModel)]="formularioObj.Estado"
              id="estadoFormulario"
              formControlName="Estado">
              <option disabled>Seleccione...</option>
              <option value="1">Diseño</option>
              <option value="2">Pruebas</option>
              <option value="3">Produccion</option>
            </select>
          </div>
          <p 
            style="color: brown;" 
            *ngIf="formForm.controls.Estado.invalid && (formForm.controls.Estado.dirty || formForm.controls.Estado.touched)"> 
              El estado es requerido
          </p>
        </div>
        <div>
          <app-text-box [frm]="formForm" formControlName="Version" type="number" [required]="true" label="Versión" (input)="onInputChange($event)"></app-text-box>
          <!-- <label 
            class="ms-Label is-required"
            for="Version">
              Versión
          </label>
          <input
            class="text-Create form-control"
            type="number"
            placeholder="Versión..."
            [(ngModel)]="formularioObj.Version"
            formControlName="Version"
          />
          <p 
            style="color: brown;" 
            *ngIf="formForm.controls.Version.invalid && (formForm.controls.Version.dirty || formForm.controls.Version.touched)"> 
              La versión del formulario no cuenta con el formato correcto 
          </p> -->
        </div>
        <app-check-box [frm]="formForm" formControlName="TodosUsuarios" label="Todos Usuarios"></app-check-box>
        <app-check-box [frm]="formForm" formControlName="Activo" label="Activo"></app-check-box>
        <!-- <div class="input-group">
          <label 
            class="ms-Label"
            for="TodosUsuarios">
              Todos Usuarios
          </label>
          <input
            class="form-check"
            type="checkbox"
            [(ngModel)]="formularioObj.TodosUsuarios"
            formControlName="TodosUsuarios"
          />
        </div>
        <div class="input-group">
          <label 
            class="ms-Label"
            for="Activo"
            >
              Activo
          </label>
          <input
            class="form-check"
            type="checkbox"
            [(ngModel)]="formularioObj.Activo"
            formControlName="Activo"
          />
        </div> -->
      </div>
      <app-form-buttons 
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando" 
        [frm]="formForm"
        (cancel)="clearFormFormulario()"
        [validate]="true">
      </app-form-buttons>
      <!-- <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button
          type="button"
          class="ms-Button ms-Dialog-action"
          (click)="clearFormFormulario()"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="ms-Button ms-Button--primary"
          [disabled]="formForm.invalid"
        >
          <span id="btnCreateEdit" class="ms-Button-label">Crear</span>
        </button>
      </div> -->
    </form>

    <!-- <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div> -->
  </div>
</div>


<!-- Modal -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-succes" appPreventOutsideClick>
    <div class="ms-Dialog-title">Formulario Almacenado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha almacenado el Formulario.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="cerrarModalFormularioGuardado()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>


  <!-- Modal Duplicar -->
  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader modal-duplicar" appPreventOutsideClick>
      <div class="ms-Dialog-title">¿Desea duplicar el formulario?</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">Duplicar formulario</p>
      </div>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button 
        type="button"
        class="ms-Button ms-Dialog-action"
        
      >
        Cancelar
      </button>
        <button
          class="ms-Button ms-Button--primary"
          (click)="duplicarFormulario()"
        >
          <span class="ms-Button-label" >Aceptar</span>
        </button>
        <div class="ms-Spinner" [hidden]="!botonProcesando">
          <div class="ms-Spinner-label">
            {{ textoBotonProcesando }}
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- Modal -->
    <div class="docs-DialogExample-lgHeader duplicado">
      <div class="ms-Dialog ms-Dialog--lgHeader duplicado-succes">
        <div class="ms-Dialog-title">Formulario Duplicado Correctamente</div>
        <div class="ms-Dialog-content">
          <p class="ms-Dialog-subText">Se ha duplicado el Formulario quedando este con el nombre {{ formularioDuplicado }}.</p>
        </div>
        <div class="ms-Dialog-actions">
          <button
            class="ms-Button ms-Dialog-action ms-Button--primary"
            
          >
            <span class="ms-Button-label">Aceptar</span>
          </button>
        </div>
      </div>
    </div>

  <!-- Modal Importar/Exportar -->
  <div class="docs-DialogExample-lgHeader">
    <div class="ms-Dialog ms-Dialog--lgHeader modal-Importar-formulario" appPreventOutsideClick>
      <div class="ms-Dialog-title" *ngIf="auxImport">¿Desea importar la configuración del formulario?</div>
      <div class="ms-Dialog-title" *ngIf="!auxImport">¿Desea exportar la configuración del formulario?</div>
      <div class="ms-Dialog-content">
        <div *ngIf="auxImport">
          <p class="ms-Dialog-subText" *ngIf="isEmpty == 'true'">El formulario está vacío, ¿desea importar la configuración?</p>
          <p class="ms-Dialog-subText" *ngIf="isEmpty == 'false'">El formulario ya tiene una configuración previa, ¿está seguro de importar una nueva configuración?</p>
        </div>

        <p class="ms-Dialog-subText" *ngIf="!auxImport">Exportar configuración del Formulario</p>
      </div>
      <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
        <button class="ms-Button ms-Button--primary" *ngIf="auxImport" (click)="importarFormulario()">
          <span class="ms-Button-label">Aceptar</span>
        </button>
        <button class="ms-Button ms-Button--primary" *ngIf="!auxImport" (click)="exportarFormulario()">
          <span class="ms-Button-label">Aceptar</span>
        </button>
        <div class="ms-Spinner" [hidden]="!botonProcesando">
          <div class="ms-Spinner-label">
            {{ textoBotonProcesando }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="docs-DialogExample-lgHeader importado-formulario">
    <div class="ms-Dialog ms-Dialog--lgHeader importado-formulario-succes">
      <div class="ms-Dialog-title">Formulario importado Correctamente</div>
      <div class="ms-Dialog-content">
        <p class="ms-Dialog-subText">Se ha importado la configuración del Formulario.</p>
      </div>
      <div class="ms-Dialog-actions">
        <button type="button" class="ms-Button ms-Dialog-action">Aceptar</button>
      </div>
    </div>
  </div>

<!-- <table
  datatable
  [dtOptions]="dtOptions"
  class="ms-Table ms-Table--selectable order-column row-border"
  style="width: 100%"
  id="datatableFormularios"
></table>
 -->

<app-modal-notify #crearModal></app-modal-notify>
 